import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalResult } from '@shared/models/ModalResult';

@Component({
  standalone: false,
  selector: 'app-confirmaton-modal',
  templateUrl: './confirmaton-modal.component.html',
  styleUrls: ['./confirmaton-modal.component.scss'],
})
export class ConfirmatonModalComponent {
  @Input() title!: string;
  @Input() subText!: string;
  @Input() buttonText!: string;
  @Input() buttonSecondaryText!: string;
  @Input() divType: string = 'text';
  @Input() comment: string = '';
  @Input() checkboxLabel: string = '';
  checked: boolean = false;

  constructor(public activeModal: NgbActiveModal) {}

  proceed(): void {
    if(this.divType === 'input') {
      const result = {
        ok: ModalResult.DELETE_OK || ModalResult.WARNING_OK,
        comment: this.comment
      }
      this.activeModal.close(result);
    }
    else if(this.divType === 'checkbox') {
      const result = {
        ok: ModalResult.WARNING_OK,
        checked: this.checked,
      };
      this.activeModal.close(result);
    }
    else if(this.divType === 'text') {
      const result = {
        ok: ModalResult.DELETE_OK || ModalResult.WARNING_OK,
      };
      this.activeModal.close(result);
    }
  }

  cancel(): void {
    const result = {
      cancel: ModalResult.DELETE_CANCEL,
    };
    this.activeModal.close(result);
  }
}
